module.exports = __webpack_public_path__ + "img/teacher.73416011.svg";